export default () => ({
  tags: [],
  status: {
    error: '',
  },
});
